import React, { useState, useEffect, useRef } from 'react';
import { LogoContainer, Icon, Label } from '../MenuBar/styles';
import { NotificationBellOutline } from 'src/assets/Images';
import { useQuery, queryCache } from 'react-query';
import { NOTIFICATIONS_UNREAD_COUNT_API, getData } from 'src/Utils';
import NotificationsTray from './NotificationsTray';
import { ButtonContainer, StyledBadge } from './styles';
function NotificationsButton() {
    var _a;
    var isFirstRender = useRef(true);
    var _b = useState(false), showTray = _b[0], setShowTray = _b[1];
    var notificationsTrayElement = useRef(null);
    var data = useQuery(NOTIFICATIONS_UNREAD_COUNT_API, function () { return getData('/ticket_notifications/unread_count'); }).data;
    var handleClick = function () {
        setShowTray(function (previous) { return !previous; });
    };
    useEffect(function () {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!showTray) {
            queryCache.invalidateQueries(NOTIFICATIONS_UNREAD_COUNT_API);
        }
    }, [showTray]);
    useEffect(function () {
        var clickOutsideHandler = function (event) {
            if (!notificationsTrayElement.current ||
                !(event.target instanceof Node)) {
                return;
            }
            if (!notificationsTrayElement.current.contains(event.target)) {
                setShowTray(false);
            }
        };
        document.addEventListener('click', clickOutsideHandler, true);
        return function () {
            document.removeEventListener('click', clickOutsideHandler);
        };
    }, []);
    return (React.createElement(ButtonContainer, { ref: notificationsTrayElement },
        React.createElement(LogoContainer, { onClick: handleClick },
            React.createElement(StyledBadge, { badgeContent: (_a = data === null || data === void 0 ? void 0 : data.unread_count) !== null && _a !== void 0 ? _a : 0, max: 9 },
                React.createElement(Icon, { src: NotificationBellOutline, alt: "Campana de notificaciones" })),
            React.createElement(Label, null, "Notificaciones")),
        showTray && React.createElement(NotificationsTray, null)));
}
export default NotificationsButton;
